import React from 'react';
import { Plus, Minus } from 'lucide-react';

export const FAQItem = ({ item, isOpen, onToggle, testId }) => (
  <div
    className={`bg-black/50 border rounded-xl overflow-hidden transition-colors duration-200 ${
      isOpen ? 'border-[#D4AF37]/50' : 'border-[#D4AF37]/15 hover:border-[#D4AF37]/30'
    }`}
  >
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left"
      data-testid={testId}
      aria-expanded={isOpen}
    >
      <span className="font-['Cormorant_Garamond'] text-base sm:text-lg text-white font-medium leading-snug">
        {item.q}
      </span>
      <span className="w-7 h-7 rounded-full border border-[#D4AF37]/40 flex items-center justify-center flex-shrink-0 text-[#D4AF37]">
        {isOpen ? <Minus className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
      </span>
    </button>

    {isOpen && (
      <div className="px-5 sm:px-6 pb-5 -mt-1">
        <div className="h-px bg-[#D4AF37]/15 mb-4" />
        <p className="text-[#E8DCC4] text-sm leading-relaxed">{item.a}</p>
      </div>
    )}
  </div>
);
